import axios from "axios";
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;
const api_token = localStorage.getItem('WWINGS_USER_TOKEN');

//* GET TODOS API -
export const loginUserApi = async (payload) => {
  console.log(payload)
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/superAdmin/login`, payload, {
    headers,
  });
};

// CREATE USER API

export const createUserApi = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/signup`, payload.payload, {
    headers,
  });
};
